import React, { useCallback, memo } from "react";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { ErrorMessage, Formik } from "formik";
import { useHistory } from "react-router-dom";
import { ENDPOINT, Routes } from "../../../constants";
import { LoginCredentials, UserRole } from "../../../types";
import { useAuth } from "../../../contexts/AuthContext";
import TextField from "../../../components/TextField";
import Button from "../../../components/Button";
import LoginImg from "../../../assets/images/login.png"
import './index.css'
import { FetchApi } from "../../../api/fetch";

const Login = React.memo(() => {
  const history = useHistory();
  const { login } = useAuth();

  const goToForgotPassword = useCallback(() => {
    history.push(Routes.FORGOT_PASSWORD);
  }, [history]);

  const gotToCreateAccount = useCallback(() => {
    history.push(Routes.CREATE_ACCOUNT);
  }, [history]);

  const onLogin = async (loginCredentials: LoginCredentials, actions: any) => {
    try {
      const data = await FetchApi({
        endpoint: `${ENDPOINT.BASE_AUTH}/login`,
        method: "POST",
        body:  (loginCredentials),
      })

      if (data.challengeName === "NEW_PASSWORD_REQUIRED") {
        history.push({ pathname: Routes.RESET_PASSWORD, state: { user: data.username, Session: data.Session } })
      } else {
        const currentUserMetadata = await login(data)
        if (currentUserMetadata?.role === UserRole.admin) {
          history.push(Routes.ADMIN_NOTIFICATIONS);
        } else {
          history.push(Routes.MANAGE_COLLECTIONS);
        }
      }
    } catch (error: any) {
      // toast.error(error.message)
      actions.setSubmitting(false);
    }
  }

  return (
    <div className="flex items-start auth">
      <div className="flex items-center mx-auto  auth-left relative" >
        <div className="flex-col items-center mx-auto w-full px-2 mt-8 sm:px-6 lg:px-4  lg:mt-16  ">
          <div className="md:shadow-lg md:p-8 flex-col items-center">
            <h1 className="h1 font-bold mb-3 ">Welcome</h1>
            <p className="mb-8 text-sm font-light text-center">
              Login to manage your collection(s).
            </p>
            <Formik
              validateOnBlur={false}
              initialValues={{
                email: "",
                password: "",
                error: "",
              }}
              validationSchema={Yup.object().shape({
                email: Yup.string()
                  .trim()
                  .required("Please enter your email address.")
                  .email("Must be a valid email."),
                password: Yup.string().required("Please enter your password."),
              })}
              onSubmit={({ error, email, password }, actions) => {
                onLogin({ email, password }, actions)
                // .then(onFinish)
                // .catch(() => {
                //   actions.setFieldError("error", "Invalid email or password");
                //   actions.setSubmitting(false);
                // });
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
              }) => (
                <form
                  onSubmit={handleSubmit}
                  noValidate
                  className="max-w-lg mx-auto flex flex-col items-center"
                >
                  <ErrorMessage name="error" />
                  <TextField
                    type="email"
                    label="Email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                    showError={touched.email && Boolean(errors.email)}
                    required
                    id="email"
                    name="email"
                    autoComplete="email"
                    placeholder="example@mail.com"
                  />
                  <TextField
                    label="Password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.password}
                    showError={touched.password && Boolean(errors.password)}
                    required
                    name="password"
                    placeholder="Min 8 characters"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                  />
                  <Button
                    className="mb-6 mt-1 w-full btn bg-gradient text-kyzzen-primary font-medium"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    LOGIN
                  </Button>
                  <Button
                    type="button"
                    className="mb-6 w-full text-right text-xs text-gray-100 hover:text-gray-500"
                    disabled={isSubmitting}
                    onClick={goToForgotPassword}
                  >
                    FORGOT PASSWORD ?
                  </Button>

                  <Button
                    type="button"
                    className="mb-6 w-full text-center text-sm text-gray-100 hover:text-gray-500 absolute bottom-0"
                    disabled={isSubmitting}
                    onClick={gotToCreateAccount}
                  >
                    Not registered yet? <span className="gradient-text"> Create an account</span>
                  </Button>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>

      <div className="auth-right">
        <img src={LoginImg} alt="login" />
      </div>
    </div>
  );
});

export default memo(Login);